//For handling submission of b2b gift card requests
(function () {
    let selectedFormType = 'inquiry';
    const orderFields = document.getElementById('orderFields'),
          btnSubmit = document.getElementById('b2bSubmit'),
          termsAccepted = document.getElementById('Terms'),
          formTypeRadios = document.querySelectorAll('input[type=radio][name="b2bFormType"]');

    formTypeRadios.forEach(radio => radio.addEventListener('change', function() {
      if (radio.id === 'formTypeOrder') {
        selectedFormType = 'order';
        orderFields.classList.add('is-visible');
      } else {
        selectedFormType = 'inquiry';
        orderFields.classList.remove('is-visible');
      }
    }));
    
    //Enable submit button if terms accepted
    termsAccepted.onchange = function() {
      if (this.checked) {
        btnSubmit.disabled = false;
      } else {
        btnSubmit.disabled = true;
      }
    };

    //Accept terms and close modal
    document.getElementById('acceptTerms').onclick = function() {
      $('#TermsAndConditionsModal').foundation('close');
      termsAccepted.checked = true;
      btnSubmit.disabled = false;
    };

    //Submit button event listener
    btnSubmit.addEventListener("click", function(event) {
      event.preventDefault();
      formSubmission();
    });

    //For removing highlighted missing input data on form re-submission
    function removeInvalidInputClasses() {
      invalid_input = document.getElementsByClassName('is-invalid-input');
      while (invalid_input[0]) {
        invalid_input[0].classList.remove('is-invalid-input');
      }
    }

    //For removing error messages from screen
    function removeErrorMessages() {
      document.querySelectorAll('.form-errors').forEach(el => el.classList.add('hidden'));
    }

    //Form submission
    function formSubmission() {
      removeInvalidInputClasses();
      removeErrorMessages();

      let selectedDeliveryRadio = document.querySelector('input[name="deliveryOptions"]:checked');
      if (!selectedDeliveryRadio) {
        document.getElementById('b2b_contact_missing_required_fields').classList.remove('hidden');
        return;
      }

      let postData = {
        formType: selectedFormType,
        companyName: '',
        contactEmail: '',
        contactName: '',
        numberOfGiftcards: document.getElementById('NumberOfGiftcards').value,
        valueOfGiftcard: document.getElementById('ValueOfGiftcard').value,
        deliverySelection: selectedDeliveryRadio.value,
        moreInformation: document.getElementById('MoreInformation').value
      };

      const requireFields = {
        companyName: 'CompanyName',
        contactEmail: 'ContactEmail',
        contactName: 'ContactName',
      };

      for (const prop in requireFields) {
        let inputValue = document.getElementById(requireFields[prop]).value;
        if (!inputValue) {
          document.getElementById('b2b_contact_missing_required_fields').classList.remove('hidden');
          return;
        }
        postData[prop] = inputValue;
      }

      if (selectedFormType === 'order') {
        postData.orderDetails = {};
        const orderDetailsFields = {
          companyNameAndVat: 'CompanyNameAndVat',
          businessAddress: 'BusinessAddress',
          billingAddress: 'BillingAddress',
          invoiceReference: 'InvoiceReference'
        };

        for (const prop in orderDetailsFields) {
          let inputValue = document.getElementById(orderDetailsFields[prop]).value;
          if (!inputValue) {
            document.getElementById('b2b_contact_missing_required_fields').classList.remove('hidden');
            return;
          }
          postData.orderDetails[prop] = inputValue;
        }
      }

      if (grecaptcha.getResponse() === '') {
        document.getElementById('b2b_contact_missing_required_fields').classList.remove('hidden');
        return;
      }

      if (termsAccepted.checked === false) {
        document.getElementById('b2b_contact_missing_accept_terms').classList.remove('hidden');
        return;
      }

      btnSubmit.disabled = true;
      console.log(postData);
      sendGiftcardRequest(postData);
    }

    //For highlighting missing or invalid fields
    function highlightMissingInvalidFields(highlightedFieldsList) {
      for (input_field in highlightedFieldsList) {
        switch (highlightedFieldsList[input_field]) {
          case 'companyName': 
            document.getElementById('CompanyName').classList.add('is-invalid-input');
            break;
          case 'contactName':
            document.getElementById('ContactName').classList.add('is-invalid-input');
            break;
          case 'contactEmail':
            document.getElementById('ContactEmail').classList.add('is-invalid-input');
            break;
        }
      }
      btnSubmit.disabled = false;
    }

    //API request
    function sendGiftcardRequest(requestData) {
      const request = new XMLHttpRequest(),
            url = 'https://suomalainen-atp.aste.dev/api/b2b/giftcard';
      request.open('POST', url);
      request.onload = function() {
        const res = JSON.parse(this.response);
        if (this.status == 500) {
          // unexpected server error
          document.getElementById("b2b_contact_generic_error").classList.remove('hidden');
          btnSubmit.disabled = false;
        } else if (res.response_type === 'invalid_format') {
          console.log("invalid_format");
          document.getElementById("b2b_contact_invalid_format").classList.remove('hidden');
          highlightedFieldsList = res.invalid_fields;
          highlightMissingInvalidFields(highlightedFieldsList);
        } else if (res.response_type === 'missing_required_fields') {
          console.log("missing_required_fields");
          document.getElementById("b2b_contact_missing_required_fields").classList.remove('hidden');
          highlightedFieldsList = res.required_fields;
          highlightMissingInvalidFields(highlightedFieldsList);
        } else if (res.response_type === 'information_send') {
          removeErrorMessages();
          document.getElementById("b2b_contact_success").classList.remove('hidden');
        } else {
          document.getElementById("b2b_contact_generic_error").classList.remove('hidden');
          btnSubmit.disabled = false;
        }
      };
      request.onerror = function() {
      // show some error log
      };
      request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      request.send(JSON.stringify({data: requestData}));
    }
})();